<!-- unassigned-customers.component.html -->
<div class="container">
    <h2>Unassigned Customers</h2>
  
    <div style="margin-bottom: 16px">
      <nz-input-group [nzSuffix]="suffixIconSearch">
        <input
          type="text"
          nz-input
          placeholder="Search temp rep name"
          [(ngModel)]="searchValue"
          (ngModelChange)="search()"
        />
      </nz-input-group>
      <ng-template #suffixIconSearch>
        <span nz-icon nzType="search"></span>
      </ng-template>
    </div>
  
    <nz-table 
    #basicTable 
    [nzData]="filteredCustomers"
    [nzLoading]="isLoading"
    (nzQueryParams)="onQueryParamsChange($event)">
    <thead>
      <tr>
        <th nzColumnKey="temp_rep_name" [nzSortFn]="true">Temp Rep Name</th>
        <th nzColumnKey="customer_name" [nzSortFn]="true">Customer Name</th>
        <th nzColumnKey="company" [nzSortFn]="true">Company</th>
        <th nzColumnKey="order_id" [nzSortFn]="true">Account Number</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let customer of basicTable.data">
        <td>{{ customer.temp_rep_name }}</td>
        <td>{{ customer.first_name }} {{ customer.last_name }}</td>
        <td>{{ customer.company }}</td>
        <td>{{ customer.order_id }}</td>
        <td>
          <button 
            nz-button 
            nzType="primary"
            (click)="showAssignUserModal(customer)">
            Assign User
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>

  </div>